export default __webpack_public_path__ + "static/media/students-2.31ce20a3.jpg";